// import moment from "moment";
// import React, { useEffect, useState } from "react";
// import { useParams, useLocation } from "react-router-dom";
// import toast from "react-hot-toast";
// import purchaseService from "../../Services/purchaseService";
// import productService from "../../Services/productService";
// import { Eye } from "lucide-react";

// const PurchaseView = () => {
//     const [loading, setLoading] = useState(false);
//     const [order, setOrder] = useState(null);
//     const [totalPurchase, setTotalPurchase] = useState(0);
//     const [totalSale, setTotalSale] = useState(0);
//     const [medicines, setMedicines] = useState([]);
//     const { id } = useParams();
//     const location = useLocation();
//     const { company, name } = location.state || {};

//     useEffect(() => {
//         const getMedicines = async () => {
//             try {
//                 setLoading(true);
//                 const response = await productService.fetchAll();
//                 console.log("Fetched Medicines:", response);
//                 setMedicines(response.products);
//             } catch (error) {
//                 toast.error("Error fetching Medicines");
//             } finally {
//                 setLoading(false);
//             }
//         };
//         getMedicines();
//     }, []);

//     useEffect(() => {
//         const fetchPurchaseById = async () => {
//             if (!id) {
//                 toast.error("No ID provided in the URL");
//                 return;
//             }
//             try {
//                 setLoading(true);
//                 const response = await purchaseService.fetchById(id);
//                 console.log("Fetched Purchase Order:", response);

//                 if (response?.purchase) {
//                     let tp = 0;
//                     let ts = 0;

//                     // Enrich details with medicine names
//                     const updatedDetails = response.purchase.details.map(detail => {
//                         const medicine = medicines.find(med => med.id === detail.medicine_id);
//                         return {
//                             ...detail,
//                             medicine_name: medicine ? medicine.medicine_name : "Unknown"
//                         };
//                     });

//                     updatedDetails.forEach(detail => {
//                         tp += parseFloat(detail.total_price);
//                         ts += detail.sale_price * detail.quantity;
//                     });

//                     setOrder({ ...response.purchase, details: updatedDetails });
//                     setTotalPurchase(tp);
//                     setTotalSale(ts);
//                 }
//             } catch (error) {
//                 toast.error("Error fetching purchase data");
//             } finally {
//                 setLoading(false);
//             }
//         };

//         if (medicines.length > 0) {
//             fetchPurchaseById();
//         }
//     }, [id, medicines]);

//     return (
//         <div className="p-4 px-16">
//             <div className="flex flex-row">
//                 <h1 className="font-bold text-2xl text-primary animate__animated animate__fadeInLeft">
//                     SAM Pharmacy
//                 </h1>
//             </div>
//             <hr className="border border-gray-200"/>

//             <div className="grid grid-cols-4 mt-4">
//                 <p className="flex flex-col font-semibold text-sm text-green-600">
//                     Order Created At:
//                     <span className="text-gray-500 font-medium">
//                         {moment(order?.date).format("LL")}
//                     </span>
//                 </p>
//                 <p className="flex flex-col font-semibold text-sm text-green-600">
//                     Order Date:
//                     <span className="text-gray-500 font-medium">
//                         {moment(order?.purchase_date).format("LL")}
//                     </span>
//                 </p>
//             </div>

//             <h1 className="font-bold text-lg mt-8">Supplier Details</h1>
//             <div className="flex justify-between">
//                 <div className="flex flex-row gap-8 mt-2">
//                     <div>
//                         <span className="block leading-none font-semibold">Company Name</span>
//                         <span className="text-sm leading-none font-medium text-gray-500">{company}</span>
//                     </div>
//                     <div>
//                         <span className="block leading-none font-semibold">Salesman Name</span>
//                         <span className="text-sm leading-none font-medium text-gray-500">{name}</span>
//                     </div>
//                   </div>
//               </div>

//               <h1 className="mt-10 font-bold text-xl text-center mb-4">Purchase Order Details</h1>
//               <div className="flex justify-center items-center">
//                 <table className="w-full border-collapse rounded-lg overflow-hidden shadow-sm shadow-gray-300">
//                         <thead>
//                             <tr className="uppercase w-full text-sm text-white bg-primary">
//                                 <th className="py-4 border-b text-left pl-4">Id</th>
//                                 <th className="py-4 border-b text-left pl-4">Medicine Name</th>
//                                 <th className="py-4 border-b text-left pl-4">Quantity</th>
//                                 <th className="py-4 border-b text-left pl-4">Unit Price</th>
//                                 <th className="py-4 border-b text-left pl-4">Batch No.</th>
//                                 <th className="py-4 border-b text-left pl-4">Sale Price</th>
//                                 <th className="py-4 border-b text-left pl-4">Expiry Date</th>
//                                 <th className="py-4 border-b text-left pl-4">Total Price</th>
//                             </tr>
//                         </thead>
//                         <tbody>
//                             {order?.details?.map((detail, index) => (
//                                 <tr key={index} className="bg-white text-left text-sm">
//                                     <td className="pl-4 border-b border-gray-100 py-2">{detail.id}</td>
//                                     <td className="pl-4 border-b border-gray-100 py-2 font-semibold">{detail.medicine_name}</td>
//                                     <td className="pl-4 border-b border-gray-100 py-2">{detail.quantity}</td>
//                                     <td className="pl-4 border-b border-gray-100 py-2 font-bold">{detail.unit_price}</td>
//                                     <td className="pl-4 border-b border-gray-100 py-2">{detail.batch_no}</td>
//                                     <td className="pl-4 border-b border-gray-100 py-2">RS {detail.sale_price}</td>
//                                     <td className="pl-4 border-b border-gray-100 py-2">{moment(detail.expiry_date).format("ll")}</td>
//                                     <td className="pl-4 border-b border-gray-100 py-2">{parseFloat(detail.unit_price * detail.quantity).toFixed(2)}</td>
//                                 </tr>
//                             ))}
//                         </tbody>
//                     </table>
//               </div>

//               <div className="flex flex-col mt-10 mb-10 text-lg font-semibold justify-end text-right">
//                     <p>Total Purchase Price:
//                     <span className="text-green-600 break-words w-[50%] ml-2">
//                         {totalPurchase} PKR
//                     </span>
//                     </p>
//                 </div>
//             </div>
//     );
// };

// export default PurchaseView;

import moment from "moment";
import React, { useEffect, useState } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import purchaseService from "../../Services/purchaseService";
import productService from "../../Services/productService";
import { MdShoppingCart, MdArrowBack, MdBusiness, MdPerson } from "react-icons/md";
import { AiOutlineLoading3Quarters } from "react-icons/ai";

const PurchaseView = () => {
  const [loading, setLoading] = useState(false);
  const [order, setOrder] = useState(null);
  const [totalPurchase, setTotalPurchase] = useState(0);
  const [totalSale, setTotalSale] = useState(0);
  const [medicines, setMedicines] = useState([]);
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const { company, name } = location.state || {};

  useEffect(() => {
    const getMedicines = async () => {
      try {
        setLoading(true);
        const response = await productService.fetchAll();
        setMedicines(response.products);
      } catch (error) {
        toast.error("Error fetching Medicines");
      } finally {
        setLoading(false);
      }
    };
    getMedicines();
  }, []);

  useEffect(() => {
    const fetchPurchaseById = async () => {
      if (!id) { toast.error("No ID provided in the URL"); return; }
      try {
        setLoading(true);
        const response = await purchaseService.fetchById(id);
        if (response?.purchase) {
          let tp = 0, ts = 0;
          const updatedDetails = response.purchase.details.map((detail) => {
            const medicine = medicines.find((med) => med.id === detail.medicine_id);
            return { ...detail, medicine_name: medicine ? medicine.medicine_name : "Unknown" };
          });
          updatedDetails.forEach((detail) => {
            tp += parseFloat(detail.total_price);
            ts += detail.sale_price * detail.quantity;
          });
          setOrder({ ...response.purchase, details: updatedDetails });
          setTotalPurchase(tp);
          setTotalSale(ts);
        }
      } catch (error) {
        toast.error("Error fetching purchase data");
      } finally {
        setLoading(false);
      }
    };
    if (medicines.length > 0) fetchPurchaseById();
  }, [id, medicines]);

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Serif+Display:ital@0;1&family=DM+Sans:opsz,wght@9..40,300;9..40,400;9..40,500;9..40,600&display=swap');
        @keyframes fadeUp {
          from { opacity: 0; transform: translateY(16px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        .fade-up { animation: fadeUp 0.5s ease both; }
      `}</style>

      <div
        className="min-h-screen bg-[#f4f7fb] py-5 px-3 sm:py-8 sm:px-4 fade-up"
        style={{ fontFamily: "'DM Sans', sans-serif" }}
      >
        <div className="max-w-[1400px] mx-auto">

          {/* ── Page Header ── */}
          <div className="mb-5 sm:mb-8 flex flex-col sm:flex-row sm:items-start sm:justify-between gap-3">
            <div>
              <div className="flex items-center gap-2.5 sm:gap-3 mb-1">
                <div
                  className="w-8 h-8 sm:w-9 sm:h-9 rounded-xl flex items-center justify-center shrink-0"
                  style={{ background: "linear-gradient(135deg, #00A95B, #007a40)" }}
                >
                  <MdShoppingCart size={17} className="text-white" />
                </div>
                <h1
                  className="text-[#0a2540] text-[18px] sm:text-[26px] leading-tight"
                  style={{ fontFamily: "'DM Serif Display', serif" }}
                >
                  Purchase Order #{id}
                </h1>
              </div>
              <p className="text-[#8a9bb0] text-[12px] sm:text-sm ml-[42px] sm:ml-12">
                HMS Pharmacy — Purchase Details
              </p>
            </div>

            {/* <button
              onClick={() => navigate(-1)}
              className="flex items-center justify-center gap-2 px-4 py-2.5 rounded-xl text-[13px] font-semibold border border-[#dde4ed] text-[#4a6080] hover:border-[#00A95B] hover:text-[#00A95B] hover:bg-[#f0fdf7] transition-all w-full sm:w-auto"
            >
              <MdArrowBack size={16} />
              Back
            </button> */}
          </div>

          {loading && !order ? (
            <div className="flex justify-center items-center py-20 sm:py-24">
              <div className="flex flex-col items-center gap-3 text-[#8a9bb0]">
                <AiOutlineLoading3Quarters size={28} className="animate-spin text-[#00A95B]" />
                <span className="text-sm">Loading purchase order…</span>
              </div>
            </div>
          ) : (
            <>
              {/* ── Date Cards ── */}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 mb-5 sm:mb-6">
                <div className="bg-white rounded-2xl border border-[#eef1f6] p-4 sm:p-5">
                  <span className="text-[11px] font-semibold uppercase tracking-[0.7px] text-[#8a9bb0]">Order Created At</span>
                  <p
                    className="text-[16px] sm:text-[18px] font-bold text-[#0a2540] mt-1"
                    style={{ fontFamily: "'DM Serif Display', serif" }}
                  >
                    {order?.date ? moment(order.date).format("LL") : "—"}
                  </p>
                </div>
                <div className="bg-white rounded-2xl border border-[#eef1f6] p-4 sm:p-5">
                    <p className="flex flex-col font-semibold text-sm text-green-600">
                   Order Date:
                   <span className="text-gray-500 font-medium">
                      {moment(order?.purchase_date).format("LL")}
                   </span>
            </p>
                </div>
              </div>

              {/* ── Supplier Details ── */}
              <div className="bg-white rounded-2xl border border-[#eef1f6] p-4 sm:p-6 mb-5 sm:mb-6">
                <h2 className="text-[12px] sm:text-[13px] font-semibold uppercase tracking-[0.8px] text-[#4a6080] mb-4">
                  Supplier Details
                </h2>
                <div className="flex flex-col sm:flex-row gap-4 sm:gap-6">
                  <div className="flex items-start gap-3">
                    <div className="w-8 h-8 rounded-lg bg-[#f0fdf7] border border-[#c6f0de] flex items-center justify-center mt-0.5 shrink-0">
                      <MdBusiness size={15} className="text-[#00A95B]" />
                    </div>
                    <div className="min-w-0">
                      <span className="text-[11px] font-semibold uppercase tracking-[0.7px] text-[#8a9bb0]">Company Name</span>
                      <p className="text-[14px] sm:text-[15px] font-semibold text-[#0a2540] mt-0.5 break-words">{company || "—"}</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-8 h-8 rounded-lg bg-[#f0fdf7] border border-[#c6f0de] flex items-center justify-center mt-0.5 shrink-0">
                      <MdPerson size={15} className="text-[#00A95B]" />
                    </div>
                    <div className="min-w-0">
                      <span className="text-[11px] font-semibold uppercase tracking-[0.7px] text-[#8a9bb0]">Salesman Name</span>
                      <p className="text-[14px] sm:text-[15px] font-semibold text-[#0a2540] mt-0.5 break-words">{name || "—"}</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* ── Order Details ── */}
              <div className="bg-white rounded-2xl border border-[#eef1f6] overflow-hidden mb-5 sm:mb-6">
                <div className="px-4 py-3.5 sm:px-6 sm:py-4 border-b border-[#eef1f6] flex items-center justify-between gap-2">
                  <h2 className="text-[11.5px] sm:text-[13px] font-semibold uppercase tracking-[0.8px] text-[#4a6080]">
                    Purchase Order Details
                  </h2>
                  {order?.details?.length > 0 && (
                    <span className="shrink-0 text-[11px] font-semibold bg-[#f0fdf7] text-[#00A95B] border border-[#c6f0de] px-2.5 py-1 rounded-full">
                      {order.details.length} item{order.details.length !== 1 ? "s" : ""}
                    </span>
                  )}
                </div>

                {/* ── Table view: md and up ── */}
                <div className="hidden md:block overflow-x-auto">
                  <table className="w-full text-left">
                    <thead>
                        <tr style={{ background: '#00A95B' }}>  
                          {["ID", "Medicine Name", "Qty", "Unit Price", "Batch No.", "Sale Price", "Expiry Date", "Total Price"].map((h) => (
                          <th
                            key={h}
                            className="px-5 py-3.5 text-[11px] font-semibold uppercase tracking-[0.6px] text-white whitespace-nowrap"
                          >
                            {h}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {order?.details?.length > 0 ? (
                        order.details.map((detail, index) => (
                          <tr
                            key={index}
                            className={`text-[13px] border-b border-[#f0f4f8] transition-colors ${
                              index % 2 === 0 ? "bg-white" : "bg-[#fafbfd]"
                            } hover:bg-[#f0fdf7]`}
                          >
                            <td className="px-5 py-3.5 font-bold text-[#00A95B]">{detail.id}</td>
                            <td className="px-5 py-3.5 font-semibold text-[#0a2540]">{detail.medicine_name}</td>
                            <td className="px-5 py-3.5 text-[#4a6080]">{detail.quantity}</td>
                            <td className="px-5 py-3.5 font-semibold text-[#0a2540]">Rs. {detail.unit_price}</td>
                            <td className="px-5 py-3.5 text-[#4a6080]">{detail.batch_no}</td>
                            <td className="px-5 py-3.5 font-semibold text-[#0a2540]">Rs. {detail.sale_price}</td>
                            <td className="px-5 py-3.5 text-[#4a6080]">
                              <span className="inline-flex text-[12px] bg-[#f4f7fb] border border-[#eef1f6] px-2.5 py-1 rounded-lg">
                                {moment(detail.expiry_date).format("ll")}
                              </span>
                            </td>
                            <td className="px-5 py-3.5 font-bold text-[#0a2540]">
                              Rs. {parseFloat(detail.unit_price * detail.quantity).toFixed(2)}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="8" className="text-center py-12 text-[#b0bcc9]">
                            <div className="flex flex-col items-center gap-2">
                              <MdShoppingCart size={28} className="text-[#dde4ed]" />
                              <span className="text-sm">No order details found.</span>
                            </div>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                {/* ── Card view: below md ── */}
                <div className="md:hidden">
                  {order?.details?.length > 0 ? (
                    <ul className="divide-y divide-[#f0f4f8]">
                      {order.details.map((detail, index) => (
                        <li key={index} className="p-4 flex flex-col gap-3">
                          {/* ID + Medicine Name */}
                          <div className="min-w-0">
                            <span className="block text-[10px] font-semibold uppercase tracking-[0.5px] text-[#8a9bb0] mb-0.5">
                              #{detail.id} · Medicine Name
                            </span>
                            <span className="font-semibold text-[#0a2540] text-[14.5px] break-words leading-snug">
                              {detail.medicine_name}
                            </span>
                          </div>

                          {/* Qty + Batch No. + Expiry Date */}
                          <div className="flex flex-wrap items-center gap-2">
                            <span className="inline-flex items-center text-[11.5px] font-semibold text-[#4a6080] bg-[#f4f7fb] border border-[#eef1f6] px-2.5 py-1 rounded-lg">
                              Qty: {detail.quantity}
                            </span>
                            <span className="inline-flex items-center text-[11.5px] text-[#4a6080] bg-[#f4f7fb] border border-[#eef1f6] px-2.5 py-1 rounded-lg">
                              Batch: {detail.batch_no}
                            </span>
                            <span className="inline-flex items-center text-[11.5px] text-[#4a6080] bg-[#f4f7fb] border border-[#eef1f6] px-2.5 py-1 rounded-lg">
                              Exp: {moment(detail.expiry_date).format("ll")}
                            </span>
                          </div>

                          {/* Unit Price + Sale Price + Total Price */}
                          <div className="flex items-end justify-between gap-3">
                            <div>
                              <span className="block text-[10px] font-semibold uppercase tracking-[0.5px] text-[#8a9bb0] mb-0.5">
                                Unit Price
                              </span>
                              <span className="font-semibold text-[#0a2540] text-[13.5px]">
                                Rs. {detail.unit_price}
                              </span>
                            </div>
                            <div className="text-right">
                              <span className="block text-[10px] font-semibold uppercase tracking-[0.5px] text-[#8a9bb0] mb-0.5">
                                Sale Price
                              </span>
                              <span className="font-semibold text-[#0a2540] text-[13.5px]">
                                Rs. {detail.sale_price}
                              </span>
                            </div>
                            <div className="text-right">
                              <span className="block text-[10px] font-semibold uppercase tracking-[0.5px] text-[#8a9bb0] mb-0.5">
                                Total Price
                              </span>
                              <span className="font-bold text-[#00A95B] text-[13.5px]">
                                Rs. {parseFloat(detail.unit_price * detail.quantity).toFixed(2)}
                              </span>
                            </div>
                          </div>
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <div className="flex flex-col items-center gap-2 text-[#b0bcc9] py-12 px-4 text-center">
                      <MdShoppingCart size={28} className="text-[#dde4ed]" />
                      <span className="text-sm">No order details found.</span>
                    </div>
                  )}
                </div>

                {/* Total Row */}
                {order?.details?.length > 0 && (
                  <div className="px-4 py-4 sm:px-6 border-t border-[#eef1f6] flex justify-center sm:justify-end">
                    <div className="bg-[#f0fdf7] border border-[#c6f0de] rounded-xl px-4 sm:px-6 py-3 flex flex-col sm:flex-row items-center gap-1 sm:gap-4 w-full sm:w-auto text-center sm:text-left">
                      <span className="text-[11px] sm:text-[12px] font-semibold uppercase tracking-[0.7px] text-[#8a9bb0]">
                        Total Purchase Price
                      </span>
                      <span
                        className="text-[18px] sm:text-[20px] font-bold text-[#00A95B]"
                        style={{ fontFamily: "'DM Serif Display', serif" }}
                      >
                        Rs. {totalPurchase.toLocaleString("en-PK", { minimumFractionDigits: 2 })} PKR
                      </span>
                    </div>
                  </div>
                )}
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default PurchaseView;